(function() {
  define('bazemont/newsletter/periodic/userForm',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsletterPeriodicUserForm', []).component('bazemontNewsletterPeriodicUserForm', {
      templateUrl: '/assets/javascripts/bazemont/newsletter/periodic/userForm.html',
      controller: [
        '$http', '$window', 'NewsletterPreferences', 'TlhNotificationService', function($http, $window, NewsletterPreferences, TlhNotificationService) {
          var edited, getIndexById, initialValue, setParentCategoryCheckbox, setUnsetCategory, vm;
          vm = this;
          edited = false;
          initialValue = null;
          setParentCategoryCheckbox = function(categoryCheckboxId, categories, categoryType) {
            var checkbox, selectedCategories;
            checkbox = document.getElementById(categoryCheckboxId);
            selectedCategories = vm.newsletterPreferences.selectedCategories.filter(function(category) {
              return category.categoryType === categoryType;
            });
            checkbox.indeterminate = false;
            checkbox.checked = false;
            if (selectedCategories.length === categories.length) {
              return checkbox.checked = true;
            } else if (selectedCategories.length === 0) {
              return checkbox.checked = false;
            } else {
              return checkbox.indeterminate = true;
            }
          };
          getIndexById = function(item, list) {
            var i, index, listItem, _i, _len;
            index = -1;
            for (i = _i = 0, _len = list.length; _i < _len; i = ++_i) {
              listItem = list[i];
              if (listItem.id === item.id) {
                index = i;
                break;
              }
            }
            return index;
          };
          setUnsetCategory = function($event, category) {
            var index;
            index = getIndexById(category, vm.newsletterPreferences.selectedCategories);
            if (index === -1 && $event.currentTarget.checked) {
              return vm.newsletterPreferences.selectedCategories.push(category);
            } else if (index > -1 && !$event.currentTarget.checked) {
              return vm.newsletterPreferences.selectedCategories.splice(index, 1);
            }
          };
          vm.$onInit = function() {
            return $http.get('/api/categories', {
              cache: true
            }).then(function(response) {
              var categories;
              categories = response.data;
              vm.associations = categories.filter(function(category) {
                return category.categoryType === 'Association';
              });
              vm.commissions = categories.filter(function(category) {
                return category.categoryType === 'Commission';
              });
              return NewsletterPreferences.get({}, function(result) {
                var _base;
                initialValue = result;
                vm.newsletterPreferences = angular.copy(initialValue);
                if ((_base = vm.newsletterPreferences).selectedCategories == null) {
                  _base.selectedCategories = [];
                }
                if (!vm.newsletterPreferences.id) {
                  vm.newsletterPreferences.sendGeneralInfo = true;
                  vm.newsletterPreferences.selectedCategories = vm.associations.concat(vm.commissions);
                }
                setParentCategoryCheckbox('checkbox-associations', vm.associations, 'Association');
                return setParentCategoryCheckbox('checkbox-commissions', vm.commissions, 'Commission');
              });
            });
          };
          vm.userHasCategory = function(category) {
            var hasCategory, selectedCategory, _i, _len, _ref;
            hasCategory = false;
            if (vm.newsletterPreferences && vm.newsletterPreferences.selectedCategories) {
              _ref = vm.newsletterPreferences.selectedCategories;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                selectedCategory = _ref[_i];
                if (selectedCategory.id === category.id) {
                  hasCategory = true;
                  break;
                }
              }
            }
            return hasCategory;
          };
          vm.checkOrUncheckAllAssociations = function($event) {
            var association, _i, _len, _ref, _results;
            _ref = vm.associations;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              association = _ref[_i];
              _results.push(setUnsetCategory($event, association));
            }
            return _results;
          };
          vm.checkOrUncheckAllCommissions = function($event) {
            var commission, _i, _len, _ref, _results;
            _ref = vm.commissions;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              commission = _ref[_i];
              _results.push(setUnsetCategory($event, commission));
            }
            return _results;
          };
          vm.clickedAssociation = function($event, category) {
            setUnsetCategory($event, category);
            return setParentCategoryCheckbox('checkbox-associations', vm.associations, 'Association');
          };
          vm.clickedCommission = function($event, category) {
            setUnsetCategory($event, category);
            return setParentCategoryCheckbox('checkbox-commissions', vm.commissions, 'Commission');
          };
          vm.submit = function() {
            if (!vm.submitting && !angular.equals(vm.newsletterPreferences, initialValue)) {
              vm.submitting = true;
              TlhNotificationService.info({
                message: 'Enregistrement en cours...',
                delay: false
              });
              return new NewsletterPreferences(vm.newsletterPreferences).$save().then(function(response) {
                initialValue = angular.copy(response);
                vm.newsletterPreferences = angular.copy(initialValue);
                return TlhNotificationService.success({
                  message: 'Enregistrement terminé',
                  replaceMessage: true
                });
              })["catch"](function(error) {
                var message;
                console.error(error);
                message = "Erreur inattendue, veuillez contacter l'administrateur.";
                return TlhNotificationService.error({
                  message: message,
                  replaceMessage: true,
                  delay: false
                });
              })["finally"](function() {
                return vm.submitting = false;
              });
            }
          };
          $window.onbeforeunload = function() {
            var result;
            result = void 0;
            if (!angular.equals(vm.newsletterPreferences, initialValue)) {
              result = 'En quittant cette page, vous perdrez les modifications non enregistrées';
            }
            return result;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=userForm.js.map
;
